export const LOGGED_STATUS = 'LOGGED_STATUS';
export const ACTIVE_NAV = 'ACTIVE_NAV';
export const USER_LIST = 'USER_LIST';
export const USER_PROFILE = 'USER_PROFILE';
export const MY_PROFILE = 'MY_PROFILE';